/**
 * Decides which errors the RUM web client's automatic capture of unhandled
 * errors and promise rejections should drop. The Apollo error link already
 * filters cancelled requests, but a fetch aborted by navigating away can also
 * reach the browser as an unhandled AbortError rejection, which RUM records
 * as "The operation was aborted." with no operation name attached.
 */
const ABORT_MESSAGES = [
  "The operation was aborted.",
  "The user aborted a request.",
  "signal is aborted without reason"
]

const isAbortError = (value: unknown): boolean => {
  if (!value || typeof value !== "object") {
    return false
  }
  const { name, message } = value as { name?: unknown; message?: unknown }
  if (name === "AbortError") {
    return true
  }
  return typeof message === "string" && ABORT_MESSAGES.includes(message.trim())
}

/**
 * Returns true when a browser error event carries a cancelled request, so
 * the RUM errors telemetry should not record it.
 *
 * @param event - the ErrorEvent or PromiseRejectionEvent RUM is about to record
 */
export const isIgnoredRumError = (event: ErrorEvent | PromiseRejectionEvent): boolean => {
  if ("reason" in event) {
    return isAbortError(event.reason)
  }
  return isAbortError(event.error) || isAbortError({ message: event.message })
}
